import VehicleBin from './VehicleBin'

export default VehicleBin
